import { batchScalingEn, processRoutingEn } from './process-routing-en';

export const processRoutingTr = {
  ...processRoutingEn,
  title: 'Proses rotası',
  subtitle: 'Bu reçete sürümü için sürümlü iş talimatları, kalite kontrolleri, verim ve kayıplar.',
  statuses: {
    DRAFT: 'Taslak',
    IN_REVIEW: 'İncelemede',
    APPROVED: 'Onaylı',
    BLOCKED: 'Bloke',
    ARCHIVED: 'Arşivli',
  },
  help: {
    ...processRoutingEn.help,
    open: 'Proses rotası yardımını aç',
    header:
      'Sabit rota numarası reçeteye aittir; her reçete sürümünün kendi kontrollü rota sürümü vardır.',
    translations: 'Adlar ve talimatlar desteklenen tüm dillerde tutulabilir.',
    steps:
      'Adımları sürükleyerek sıralayın. Ondalık faktörler sunucuda kayan nokta kullanılmadan hesaplanır.',
    history: 'Her rota sürümü reçete sürümüne bağlı kalır ve gönderildikten sonra değiştirilemez.',
    saveBeforeDocuments:
      'Belge ve fotoğrafları korumalı DMS kaydına yüklemeden önce rotayı kaydedin.',
    snapshotDocuments: 'Seçilen korumalı asıllar değişmez belge anlık görüntüsünü oluşturur.',
  },
  actions: {
    reorder: 'Proses adımını sırala',
    scaleBatch: 'Partiyi ölçekle',
    submit: 'İncelemeye gönder',
    review: 'İncelemeyi tamamla',
    approve: 'Onayla',
    copy: 'Yeni rota sürümü',
    block: 'Bloke et',
    archive: 'Arşivle',
    addStep: 'Adım ekle',
    addByproduct: 'Yan ürün ekle',
  },
  messages: {
    saved: 'Proses rotası kaydedildi.',
    invalid: 'Geçersiz rota verilerini veya JSON yapılarını düzeltin.',
    submitted: 'Rota bağımsız incelemeye gönderildi.',
    workflowUpdated: 'Rota iş akışı güncellendi.',
  },
  sections: {
    header: 'Rota başlığı',
    translations: 'Diller',
    steps: 'Proses adımları',
    history: 'Sürüm geçmişi',
    documents: 'Rota DMS kaydı',
    snapshotDocuments: 'Sürüm belge anlık görüntüsü',
    stepTranslations: 'Çevrilmiş adım talimatları',
    byproducts: 'Yan ürünler',
    stepDocuments: 'Adım belgeleri ve fotoğrafları',
  },
  fields: {
    ...processRoutingEn.fields,
    number: 'Rota numarası',
    name: 'Ad',
    processFactor: 'Hesaplanan toplam proses faktörü',
    description: 'Açıklama',
    localizedName: 'Çevrilmiş ad',
    position: 'Pozisyon',
    stepName: 'Adım adı',
    workplace: 'İş merkezi / alan',
    input: 'Girdi',
    output: 'Çıktı',
    yield: 'Verim %',
    loss: 'Kayıp %',
    version: 'Rota sürümü',
    recipeVersion: 'Reçete sürümü',
    status: 'Durum',
    updated: 'Son değişiklik',
    workCenter: 'İş merkezi',
    productionArea: 'Üretim alanı',
    inputQuantity: 'Girdi miktarı',
    inputUnit: 'Girdi birimi',
    outputQuantity: 'Çıktı miktarı',
    outputUnit: 'Çıktı birimi',
    targetTime: 'Hedef süre (dk)',
    setupTime: 'Kurulum (dk)',
    duration: 'Süre (dk)',
    temperature: 'Sıcaklık',
    temperatureUnit: 'Sıcaklık birimi',
    scrap: 'Fire %',
    absorption: 'Emilim %',
    instructions: 'İş talimatları',
    parameters: 'Yapılandırılabilir parametreler (JSON)',
    qualityChecks: 'Kalite kontrolleri (JSON)',
    product: 'Ürün',
    document: 'Belge',
    photo: 'Fotoğraf',
    reason: 'İzlenebilir gerekçe / not',
  },
  states: { noDocuments: 'Korumalı proses belgesi yok.' },
  stepDialog: {
    title: 'Proses adımını düzenle',
    description: 'Miktar, süre, parametre, kontrol, kayıp, talimat, yan ürün ve kanıtları yönetin.',
  },
  actionDialog: {
    REVIEW: {
      title: 'Teknik incelemeyi tamamla',
      description: 'Bağımsız incelemeyi izlenebilir bir notla doğrulayın.',
    },
    APPROVE: {
      title: 'Rotayı onayla',
      description: 'Onay rotayı dondurur; onaylı reçete ve dört göz ayrımı gerekir.',
    },
    COPY: {
      title: 'Yeni rota sürümü oluştur',
      description: 'Bu anlık görüntüyü kaynak bağlantısıyla yeni bir taslağa kopyalar.',
    },
    BLOCK: {
      title: 'Rotayı bloke et',
      description: 'Kontrollü sürüm değişmez kalır ancak kullanılamaz.',
    },
    ARCHIVE: {
      title: 'Rotayı arşivle',
      description: 'Sürüm izlenebilir kalır ve aktif kullanımdan çıkar.',
    },
  },
} as const;

export const batchScalingTr = {
  ...batchScalingEn,
  title: 'Parti ölçekleme',
  subtitle: 'Her iki yönde sunucu tarafında yeniden üretilebilir malzeme hesabı.',
  help: {
    open: 'Parti ölçekleme yardımını aç',
    input: 'Onaylı reçete, yön, çıktı birimi ve isteğe bağlı onaylı ikameleri seçin.',
    materials: 'İhtiyaçlar kayıpları ve tüm alt reçeteleri içerir, hedef birime göre yuvarlanır.',
    formulas: 'Her ara sonuç ve sunucunun kullandığı kesin formül gösterilir.',
  },
  sections: {
    input: 'Hesap girdileri',
    materials: 'Malzeme ihtiyaçları',
    limiting: 'Sınırlayıcı malzemeler',
    subRecipes: 'Çözümlenen alt reçeteler',
    byproducts: 'Beklenen yan ürünler',
    formulas: 'Formüller ve ara sonuçlar',
    substitutions: 'Onaylı ikameler',
    available: 'Mevcut başlangıç malzemeleri',
  },
  fields: {
    recipe: 'Reçete sürümü',
    direction: 'Hesap yönü',
    outputUnit: 'Çıktı birimi',
    position: 'Pozisyon {{position}}',
    primaryComponent: 'Ana bileşeni kullan',
    targetQuantity: 'İstenen son miktar',
    material: 'Malzeme',
  },
  directions: {
    TARGET_OUTPUT: 'Son miktar → gerekli malzemeler',
    AVAILABLE_INPUT: 'Mevcut malzeme → mümkün son miktar',
  },
  actions: { addMaterial: 'Malzeme ekle', calculate: 'Partiyi hesapla' },
  result: {
    output: 'Mümkün / istenen çıktı',
    scale: 'Referans ölçeği',
    processFactor: 'Toplam proses faktörü',
    referenceOutput: 'Etkin referans çıktısı',
    level: 'BOM seviyesi {{level}}',
  },
  columns: {
    article: 'Ürün',
    type: 'Tür',
    quantity: 'Gerekli miktar',
    source: 'Kaynak yolları',
    available: 'Mevcut',
    requiredReference: 'Referans ihtiyacı',
    possibleOutput: 'Mümkün çıktı',
  },
  componentTypes: { MATERIAL: 'Malzeme', PACKAGING: 'Ambalaj' },
  states: { none: 'Yok.' },
  messages: { invalid: 'Hesap girdileri geçersiz.' },
  formulas: {
    PROCESS_STEP_FACTOR: 'Proses adımı faktörü',
    OVERALL_PROCESS_FACTOR: 'Toplam proses faktörü',
    ROOT_RECIPE_SCALE: 'Ana reçete ölçeği',
    COMPONENT_GROSS_REQUIREMENT: 'Brüt bileşen ihtiyacı',
    SUB_RECIPE_SCALE: 'Alt reçete ölçeği',
    AVAILABLE_MATERIAL_OUTPUT: 'Malzemeden mümkün çıktı',
  },
  warnings: {
    PROCESS_ROUTING_MISSING_ASSUMED_100_PERCENT:
      'Proses rotası yok; %100 verim varsayılır ve kontrol edilmelidir.',
    PROCESS_ROUTING_NOT_APPROVED: 'Seçilen proses rotası onaylı değil.',
    STEP_YIELD_MISSING_ASSUMED_100_PERCENT:
      'Bir adımda verim veya girdi/çıktı yok; %100 varsayılır.',
    STEP_YIELD_CONTRADICTS_INPUT_OUTPUT: 'Girilen verim adımın girdi/çıktı oranıyla çelişiyor.',
    RECIPE_VERSION_NOT_APPROVED: 'Hiyerarşide en az bir reçete sürümü onaylı değil.',
    COMPONENT_PRODUCT_BLOCKED_OR_ARCHIVED: 'Gerekli bir ürün bloke veya kullanımdan kalkmış.',
    MATERIAL_AVAILABILITY_NOT_PROVIDED:
      'Bu gerekli malzeme için mevcudiyet verilmedi; sonucu sınırlamaz.',
    AVAILABLE_MATERIAL_NOT_REQUIRED: 'Girilen bir malzeme seçilen yapıda gerekli değil.',
  },
} as const;
